import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f507ec98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-message-template" }
const _hoisted_2 = { class: "cm-message-header" }
const _hoisted_3 = { class: "cm-message-body" }
const _hoisted_4 = ["title"]

import { computed, PropType } from 'vue'
import { i18n } from '@/i18n'
import { Content } from '@/views/_components/message-template/service-expired/service-expired.service'
import { getListShow } from '@/utils/tool'


export default /*#__PURE__*/_defineComponent({
  __name: 'service-expired',
  props: {
  content: {
    type: Object as PropType<Content>,
    default: () => ({} as any)
  },
  notificationKey: {
    type: String,
  }
},
  emits: ['closeDetails'],
  setup(__props) {



const props = __props

const t = i18n.global.t.bind(i18n.global)

const listSeparator = computed(() => t('messageTemplate.listSeparator'))

const serviceNamesTitle = computed(() =>
  props.content.service_names.join(listSeparator.value)
)

const serviceListText = computed(() =>
  getListShow({ list: props.content.service_names, separator: listSeparator.value })
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('messageTemplate.serviceExpired.header')), 1),
    _createElementVNode("div", _hoisted_3, [
      (__props.content.service_names.length)
        ? (_openBlock(), _createElementBlock("strong", {
            key: 0,
            title: serviceNamesTitle.value
          }, _toDisplayString(serviceListText.value) + _toDisplayString(_unref(t)('messageTemplate.serviceSuffix')), 9, _hoisted_4))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_unref(t)('messageTemplate.serviceExpired.expiredAt')) + " ", 1),
      _createElementVNode("strong", null, _toDisplayString(__props.content.expired_time), 1),
      _createTextVNode(" " + _toDisplayString(_unref(t)('messageTemplate.serviceExpired.expiredSuffix')), 1)
    ])
  ]))
}
}

})